/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-03, 10:20:17
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-06, 14:54:44
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import Vue from 'vue';
import store from '@/store';
import { mapGetters } from 'vuex';

// COMPONENTS //////////////////////////////////////////////////////////////////
import MyAccountBanner from '@/components/MyAccount/MyAccountBanner';
import MyNumberCard from '@/components/MyAccount/MyNumberCard';
import MyRechargesCard from '@/components/MyAccount/MyRechargesCard';
import PromotionInfoCard from '@/components/MyAccount/PromotionInfoCard';
import PrepaidBestsellersCard from '@/components/MyAccount/PrepaidBestsellersCard';
import MockCardOnMyAccount from '@/components/Common/MockCardOnMyAccount';
import PackageUsage from '@/components/MyAccount/PackageUsage';
import SmartColumnLayout from '@/components/Help/SmartColumnLayout';

// CONTAINER ///////////////////////////////////////////////////////////////////
const MyAccount = {
  components: {
    MyAccountBanner,
    MyNumberCard,
    MyRechargesCard,
    PromotionInfoCard,
    PrepaidBestsellersCard,
    PackageUsage,
    MockCardOnMyAccount,
    SmartColumnLayout,
  },
  store,

  computed: {
    ...mapGetters(['subscriber', 'mainComponentsVisibility', 'lastInvoice', 'pendingStoreActions', 'acl']),
    mainComponents() {
      return Object.keys(this.mainComponentsVisibility)
        .filter(name => name !== 'MyAccountBanner');
    },
  },

  template: `
    <div class="container-fluid animated fadeIn">
      <div slot="item" v-if="mainComponentsVisibility['MyAccountBanner']">
        <MyAccountBanner :zeroPriorityClass="'MobileOnly'" :positivePriorityClass="'Hidden'"/>
      </div>
      <SmartColumnLayout>
        <div slot="item">
          <p class="myaccount-title">Start</p>
          <div v-if="!pendingStoreActions.includes('getInformationAboutMainComponentsVisibility')">
            <template v-for="component in mainComponents">
              <div v-if="mainComponentsVisibility[component]">
                <component :is="component"
                  :subscriber="subscriber"
                  :last-invoice="lastInvoice"
                  :acl="acl"
                />
              </div>
            </template>
          </div>
        </div>
        <div slot="item" v-if="mainComponentsVisibility['MyAccountBanner']">
          <MyAccountBanner :title="'Wybrane dla Ciebie'" :zeroPriorityClass="'DesktopOnly'" />
        </div>
        <MockCardOnMyAccount slot="item" v-if="pendingStoreActions.includes('getInformationAboutMainComponentsVisibility')" />
      </SmartColumnLayout>
    </div>
  `,
};

export default Vue
  .component('MyAccount', MyAccount);



// WEBPACK FOOTER //
// ./src/containers/MyAccount/index.js